import {
  SimpleShowLayout,
  Show,
  TextField,
  NumberField,
  Labeled,
} from "react-admin";
import { Grid, useMediaQuery } from "@mui/material";
import { settings } from "app";
import BackButtonToolbar from "features/BackButtonToolbar";
import { SectionTitle } from "features/SectionTitle";

const ShowCamps = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  return (
    <Show
      title="Детайли за лагер"
      actions={<BackButtonToolbar />}
    >
      <SimpleShowLayout>
        <SectionTitle
          title="Информация"
          textAlign="center"
          sx={{ marginTop: "2rem" }}
        />
        <Grid
          spacing={2}
          container
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Име на български език">
              <TextField source="nameBg" />
            </Labeled>
          </Grid>

          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Име на английски език">
              <TextField source="nameEn" />
            </Labeled>
          </Grid>

          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Местоположение">
              <TextField source="location" />
            </Labeled>
          </Grid>

          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Началo на регистрация">
              <TextField source="registrationStart" />
            </Labeled>
          </Grid>

          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Край на регистрация">
              <TextField source="registrationEnd" />
            </Labeled>
          </Grid>

          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Начална дата">
              <TextField source="startDate" />
            </Labeled>
          </Grid>

          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Крайна дата">
              <TextField source="endDate" />
            </Labeled>
          </Grid>

          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Капацитет">
              <NumberField source="capacity" />
            </Labeled>
          </Grid>

          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Резерва">
              <NumberField source="reserve" />
            </Labeled>
          </Grid>
        </Grid>
      </SimpleShowLayout>
      <SimpleShowLayout>
        <SectionTitle
          title="Описание"
          textAlign="center"
          sx={{ marginTop: "2rem" }}
        />
        <Grid
          spacing={2}
          container
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid
              item
              xs={12}
              md={4}
            >
            <Labeled label="Описание">
              <TextField source="description" />
            </Labeled>
          </Grid>
        </Grid>
      </SimpleShowLayout>
    </Show>
  );
};

export default ShowCamps;
